import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { NavItems, PdapNavItems } from './NavItems';
import EnvironmentHighlighter from './EnvironmentHighlighter';
import NavBar from './NavBar';

export const NDCHeader = props => (
  <span>
    <NavBar pathname={props.location.pathname} push={props.history.push} navItems={props.isPDAP ? PdapNavItems(props.isStaging) : NavItems} isPDAP={props.isPDAP}/>
    <EnvironmentHighlighter />
  </span>
);

NDCHeader.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  isPDAP: PropTypes.bool,
  isStaging: PropTypes.bool,
};

export default withRouter(NDCHeader);
